var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEnlarge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 4.42535L13 8C13 8.55228 13.4477 9 14 9C14.5523 9 15 8.55229 15 8L15 2C15 1.44772 14.5523 1 14 1H8C7.44772 1 7 1.44771 7 2C7 2.55228 7.44772 3 8 3L11.5969 3L3 11.5969L3 8C3 7.44772 2.55228 7 2 7C1.44772 7 1 7.44772 1 8V14C1 14.5523 1.44772 15 2 15H8C8.55228 15 9 14.5523 9 14C9 13.4477 8.55228 13 8 13H4.42535L13 4.42535Z",
    fill: "#001A39"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnlarge);
export default __webpack_public_path__ + "static/media/Enlarge.46374b51559469cc2558cfcf4de3df7a.svg";
export { ForwardRef as ReactComponent };